
import { Book } from "lucide-react";

const ContentLibraryHeader = () => {
  return (
    <div className="flex items-center justify-between">
      <div className="space-y-1">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-2">
          <Book className="h-6 w-6 sm:h-8 sm:w-8 text-primary flex-shrink-0" />
          <span className="leading-tight">Biblioteca de Conteúdo</span>
        </h2>
        <p className="text-muted-foreground text-sm sm:text-base">
          Explore tutoriais, guias e vídeos para maximizar o uso da plataforma
        </p>
      </div>
    </div>
  );
};

export default ContentLibraryHeader;
